import React, { useState, useEffect, useContext } from "react";
import "react-phone-input-2/lib/style.css";
import "react-datepicker/dist/react-datepicker.css";
import { Row, Col, Form, InputGroup, Modal, Button } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import classNames from "classnames";
import { RegxExpression } from "../../../../utils/common";
import Select from "react-select";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Context } from "../../../../utils/context";
import { Cities } from "../../../../utils/apis/master/Master";
import { getDimension, postData } from "../../../../utils/api";
import Cookies from "js-cookie";
import ScrollToTop from "../../../ScrollTotop/ScrollTotop";
function Stepfour(props, nextStep) {
  const [selectedOption, setSelectedOption] = useState(null);
  const { getData, IMG_URL, Select2Data } = useContext(Context);
  const options = [
    { value: "Nashik", label: "Chocolate" },
    { value: "Pune", label: "Strawberry" },
    { value: "Mumbai", label: "Vanilla" },
  ];

  const [user_id, setUserId] = useState("");
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const {
    control,
    register,
    handleSubmit,
    getValues,
    setValue,
    watch,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm();


  const watchWaUpdates = watch("wa_updates", false);
  const imageFile1 = watch("logo");
  const imageFile2 = watch("banner");

  const onSubmit = async (data) => {

    const formData = new FormData();
    if (data?.id) {
      formData.append("id", data.id);
    }
    formData.append("user_id", user_id);
    formData.append("store_name", data?.store_name);
    formData.append("area", data?.area);
    formData.append("contact_no", data?.contact_no);
    formData.append("wa_contact_no", data?.wa_contact_no);
    formData.append("city_id", data?.city_id.value || "");
    formData.append("btb_or_btc", data?.btb_or_btc);
    formData.append("logo", data?.logo?.[0]);
    formData.append("banner", data?.banner?.[0]);

    try {
      const res = await postData("/seller/s-store-details", formData);
      if (res?.success) {
        props.nextStep();
      } else {

        console.error("Failed to submit data");
        if (res?.message && typeof res.message === "object") {
          Object.entries(res.message).forEach(([field, message]) => {
            setError(field, {
              type: "server",
              message,
            });
          });
        }
      }
    } catch (error) {
      // Handle any errors that occur during the request
      console.error("An error occurred while submitting data:", error);
    }
  };

  const [city, setCity] = useState([]);

  const getEditData = async () => {
    const res = await getData(`/seller/s-store-details/${user_id}`);
    if (res?.success) {
      const formValues = res.data;

      const selectedCity = city.find(
        (c) => c.value === formValues.city_id.value
      );

      reset({
        ...formValues,
        city_id: selectedCity || null,
      });
    }
  };

  useEffect(() => {
    if (user_id && city.length > 0) {
      getEditData();
    }
  }, [user_id, city]);

  const getCity = async () => {
    const res = await Cities();
    if (res?.success) {
      const data = await Select2Data(res?.data, "city_id", false);
      setCity(data);
    }
  };

  useEffect(() => {
    getCity();
    setUserId(Cookies.get("user_id"));
  }, []);

  const [charCount, setCharCount] = useState(0);
  const maxCharLimit = 100;

  const handleInputChange = (e) => {
    setCharCount(e.target.value.length);
  };

  return (
    <>
      <ScrollToTop />
      <div className="personal-details-form ">
        <div className="details-form-holder">
          <div className="form-container">
            <Form onSubmit={handleSubmit(onSubmit)}>
              <div className="">
                <div className="row ">
                  <div className="col-md-6">
                    <Form.Group>
                      <Form.Label className="required">City*</Form.Label>
                      <Controller
                        name="city_id"
                        control={control}
                        rules={{ required: "City is required" }}
                        render={({ field }) => (
                          <Select
                            {...field}
                            options={city}
                            getOptionValue={(option) => option.value}
                            getOptionLabel={(option) => option.label}
                            onChange={(option) => field.onChange(option)}
                            value={field.value}
                            placeholder="Select City"
                          />
                        )}
                      />

                      {errors.city_id && (
                        <span className="text-danger">
                          {errors.city_id.message}
                        </span>
                      )}
                    </Form.Group>
                  </div>
                  <div className="col-md-6 mb-3">
                    <div className="field-bottom">
                      <Form.Group controlId="area">
                        <Form.Label className="required">Area*</Form.Label>
                        <InputGroup>
                          <Form.Control
                            type="text"
                            name="area"
                            placeholder="Area"
                            className={classNames("", {
                              "is-invalid": errors?.area,
                            })}
                            {...register("area", {
                              required: "Area is required",
                              maxLength: {
                                value: maxCharLimit,
                                message: `Name cannot exceed ${maxCharLimit} characters`,
                              },
                            })}
                            maxLength={maxCharLimit}
                            onChange={handleInputChange}
                          />{" "}
                        </InputGroup>

                        <div className="d-flex justify-content-between">
                          <div>
                            {errors.area && (
                              <span className="text-danger">
                                {errors.area.message}
                              </span>
                            )}
                          </div>
                          <div className="text-end">
                            <small>{maxCharLimit} characters Limit </small>
                          </div>
                        </div>
                      </Form.Group>
                    </div>
                  </div>
                </div>
              </div>

              <div className="">
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <div className="form-field">
                      <Form.Group controlId="store_name ">
                        <Form.Label className="required">
                          Shop / Showroom Name*
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="store_name"
                          placeholder="Enter Shop/Showroom Name"
                          {...register("store_name", {
                            required: "Store name required",
                            maxLength: {
                              value: maxCharLimit,
                              message: `Name cannot exceed ${maxCharLimit} characters`,
                            },
                          })}
                          className={classNames("", {
                            "is-invalid": errors?.store_name,
                            "is-valid": getValues("store_name"),
                          })}
                          maxLength={maxCharLimit}
                          onChange={handleInputChange}
                        />{" "}
                        <div className="d-flex justify-content-between">
                          <div>
                            {errors.store_name && (
                              <span className="text-danger">
                                {errors.store_name.message}
                              </span>
                            )}
                          </div>
                          <div className="text-end">
                            <small>{maxCharLimit} characters Limit </small>
                          </div>
                        </div>
                      </Form.Group>
                    </div>
                  </div>

                  <div className="col-md-6 mb-3">
                    <div className="form-field">
                      <Form.Group controlId="store_type">
                        <Form.Label className="required">
                          Seller Type*
                        </Form.Label>
                        <Form.Select
                          name="btb_or_btc"
                          {...register("btb_or_btc", {
                            required: "Type is required",
                          })}
                          className={classNames("", {
                            "is-invalid": errors?.btb_or_btc,
                          })}
                        >
                          <option value="" disabled>
                            Select Type
                          </option>
                          {/* <option value="B2B">B2B</option> */}
                          <option value="B2C">B2C</option>
                        </Form.Select>
                        {errors.btb_or_btc && (
                          <span className="text-danger">
                            {errors.btb_or_btc.message}
                          </span>
                        )}
                      </Form.Group>
                    </div>
                  </div>

                  <div className="col-md-6 mb-3">
                    <div className="field-bottom">
                      <Form.Group controlId="contact_no">
                        <Form.Label className="required form-field">
                          Owner Contact Number*
                        </Form.Label>
                        <div className="get-otp-text">
                          <Form.Control
                            type="text"
                            name="contact_no"
                            placeholder="Contact No."
                            {...register("contact_no", {
                              required: "Contact No. is required",
                              validate: {
                                isTenDigits: (value) =>
                                  (value && value.length === 10) ||
                                  "Contact number must be 10 digits",
                                isNumeric: (value) =>
                                  /^\d+$/.test(value) ||
                                  "Contact number must be numeric",
                              },
                            })}
                            className={classNames("", {
                              "is-invalid": errors?.contact_no,
                              "is-valid":
                                !errors?.contact_no &&
                                getValues("contact_no")?.length === 10,
                            })}
                            onKeyDown={(event) => {
                              const { key } = event;
                              if (
                                !/[0-9]/.test(key) &&
                                key !== "Backspace" &&
                                key !== "Tab"
                              ) {
                                event.preventDefault();
                              }
                              if (
                                event.target.value?.length >= 10 &&
                                key !== "Backspace" &&
                                key !== "Tab"
                              ) {
                                event.preventDefault();
                              }
                            }}
                          />
                          {errors.contact_no && (
                            <span className="text-danger">
                              {errors.contact_no.message}
                            </span>
                          )}
                        </div>
                      </Form.Group>
                    </div>
                  </div>
                  <div className="col-md-6 mb-3">
                    <Form className="field-bottom">
                      <Form.Group controlId="wa_contact_no">
                        <Form.Label className="required">
                          WhatsApp Number*
                        </Form.Label>
                        <div className="get-otp-text">
                          <Form.Control
                            type="text"
                            name="wa_contact_no"
                            placeholder="WhatsApp No."
                            {...register("wa_contact_no", {
                              required: "WhatsApp Number is required",
                              validate: (value) => {
                                if (value) {
                                  if (value.length !== 10) {
                                    return "Contact number must be 10 digits";
                                  }
                                  if (!/^\d+$/.test(value)) {
                                    return "Contact number must be numeric";
                                  }
                                }
                                return true; // Return true if validation passes
                              },
                            })}
                            className={classNames("", {
                              "is-invalid": errors?.wa_contact_no,
                              "is-valid":
                                !errors?.wa_contact_no &&
                                getValues("wa_contact_no")?.length === 10,
                            })}
                            onKeyDown={(event) => {
                              const { key } = event;
                              if (
                                !/[0-9]/.test(key) &&
                                key !== "Backspace" &&
                                key !== "Tab"
                              ) {
                                event.preventDefault();
                              }
                              if (
                                event.target.value?.length >= 10 &&
                                key !== "Backspace" &&
                                key !== "Tab"
                              ) {
                                event.preventDefault();
                              }
                            }}
                          />
                          {errors.wa_contact_no && (
                            <span className="text-danger">
                              {errors.wa_contact_no.message}
                            </span>
                          )}
                        </div>
                      </Form.Group>
                    </Form>
                  </div>

                  <div className="col-md-6">
                    <div className="form-field mb-4">
                      <Form.Group controlId="Last_Name">
                        <Form.Label className="required">Logo*</Form.Label>
                        <div>
                          <Form.Control
                            className={classNames("", {
                              "is-invalid": errors?.logo,
                            })}
                            type="file"
                            {...register("logo", {
                              required: "Logo is required",
                              validate: async (value) => {
                                if (
                                  value &&
                                  typeof value !== "string" &&
                                  value[0] instanceof File
                                ) {
                                  const sizes = await getDimension(value?.[0]);
                                  if (
                                    sizes.width !== 690 ||
                                    sizes.height !== 690
                                  ) {
                                    return "Image width and height must be 690 px and 690 px";
                                  }
                                }
                                return true;
                              },
                            })}
                            accept=".jpg, .jpeg, .png"
                            multiple={false}
                          />
                        </div>
                      </Form.Group>{" "}
                      {errors.logo && (
                        <span className="text-danger">
                          {errors.logo.message}
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="main-form-section mt-3">
                      <Row className="justify-content-center">
                        <Form.Label>Logo Preview </Form.Label>

                        {typeof getValues("logo") == "string" ? (
                          <div
                            className="image-preview-container mt-3"
                            style={{ marginLeft: "110px" }}
                          >
                            <img
                              src={IMG_URL + getValues("logo")}
                              alt="Preview"
                              className="image-preview"
                              style={{ width: "50px", height: "50px" }}
                            />
                          </div>
                        ) : (
                          imageFile1 &&
                          imageFile1?.length > 0 && (
                            <div
                              className="image-preview-container mt-3"
                              style={{ marginLeft: "110px" }}
                            >
                              <img
                                // src={URL.createObjectURL(getValues("image")[0])}
                                src={URL?.createObjectURL(imageFile1[0])}
                                alt="Preview"
                                className="image-preview"
                                style={{ width: "50px", height: "50px" }}
                              />
                            </div>
                          )
                        )}
                      </Row>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-field mb-4">
                      <Form.Group controlId="Last_Name">
                        <Form.Label className="required">Banner*</Form.Label>
                        <div>
                          <Form.Control
                            className={classNames("", {
                              "is-invalid": errors?.banner,
                            })}
                            type="file"
                            {...register("banner", {
                              required: "Banner is required",
                              validate: async (value) => {
                                if (
                                  value &&
                                  typeof value !== "string" &&
                                  value[0] instanceof File
                                ) {
                                  const sizes = await getDimension(value?.[0]);
                                  if (
                                    sizes.width !== 1221 ||
                                    sizes.height !== 410
                                  ) {
                                    return "Image width and height must be 1221 px and 410 px";
                                  }
                                }
                                return true;
                              },
                            })}
                            accept=".jpg, .jpeg, .png"
                            multiple={false}
                          />
                        </div>
                      </Form.Group>
                      {errors.banner && (
                        <span className="text-danger">
                          {errors.banner.message}
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="main-form-section mt-3">
                      <Row className="justify-content-center">
                        <Form.Label>Banner Preview </Form.Label>

                        {typeof getValues("banner") == "string" ? (
                          <div
                            className="image-preview-container mt-3"
                            style={{ marginLeft: "110px" }}
                          >
                            <img
                              src={IMG_URL + getValues("banner")}
                              alt="Preview"
                              className="image-preview"
                              style={{ width: "50px", height: "50px" }}
                            />
                          </div>
                        ) : (
                          imageFile2 &&
                          imageFile2?.length > 0 && (
                            <div
                              className="image-preview-container mt-3"
                              style={{ marginLeft: "110px" }}
                            >
                              <img
                                // src={URL.createObjectURL(getValues("image")[0])}
                                src={URL?.createObjectURL(imageFile2[0])}
                                alt="Preview"
                                className="image-preview"
                                style={{ width: "50px", height: "50px" }}
                              />
                            </div>
                          )
                        )}
                      </Row>
                    </div>
                  </div>

                  <div className="col-md-12">
                    <div className="text-end apply_now_btn">
                      <div className="registerContinueMain">
                        <Button
                          onClick={props.prevStep}
                          className="back-btn me-3"
                        >
                          Back
                        </Button>
                        <Button
                          className="tabs-btn"
                          type="submit"
                          // onClick={props.nextStep}
                        >
                          Next
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </>
  );
}

export default Stepfour;
